import { useState, useEffect } from 'react';
import {Bounce, toast} from "react-toastify";
import {getUsers} from "../../services/Sysadmin/getUsers";

export const useGetUsers = ({filters = {}, clearFilters} : { filters : any, clearFilters: () => void}) => {
    const [users, setUsers] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response: any = await getUsers(page, filters);
                setUsers(response.users);
                setPage(response.page)
                setTotalPages(response.totalPages);
            } catch (error:any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                        if (clearFilters) {
                            clearFilters();
                        }
                    } else {
                        toast.error("Error al obtener los usuarios.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error(error.message, {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            } finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchData();
    }, [page,filters]);

    return { users, totalPages, isLoading, page, setPage };
};
